import React from "react";
import useFilters from "hooks/useFilters";
import { Image } from "@leafly-com/frontend-components";
import { Action, Category, trackEvent } from "utils/trackEvent";
import { DeviceScreenSizes } from "custom-types/DeviceScreenSizes";
import classnames from "classnames";

type Props = {
  asLink?: boolean;
  linkToDeals?: boolean;
  className?: string;
};

const PhenotypeCarousel: React.FC<Props> = ({
  asLink,
  linkToDeals,
  className,
}) => {
  const { selectQueryValue, addQuery } = useFilters();
  const selectedPhenotype = selectQueryValue("strain_category");

  const handlePhenotypeClick = (e: React.MouseEvent<HTMLElement>) => {
    const phenotype = e.currentTarget?.dataset?.phenotype;
    addQuery({
      strain_category: phenotype,
    });
    trackEvent(
      Category.searchResults,
      Action.searchResultClicked,
      `phenotype quick access - ${phenotype}`
    );
  };

  const wrapperClass = "flex-shrink-0 flex-grow-0 mr-md";
  const coinClass = "flex flex-col items-center coin__image";

  const coinContent = (phenotype: string) => (
    <>
      <Image
        src={`https://public.leafly.com/strains/type/${phenotype.toLowerCase()}.svg`}
        sizes={[120, 156]}
        alt={""}
        className="w-full rounded-full bg-white elevation-low"
      />

      <div
        className={classnames("text-sm font-bold mt-lg", {
          "text-green": !selectedPhenotype || phenotype === selectedPhenotype,
        })}
      >
        {phenotype}
      </div>
    </>
  );

  return (
    <>
      <div
        className={classnames(
          "flex justify-start flex-no-wrap overflow-auto",
          className
        )}
      >
        {["Indica", "Sativa", "Hybrid"].map((phenotype) =>
          asLink ? (
            <a
              key={phenotype}
              href={`/search/shop/phenotype?strain_category=${phenotype}${
                linkToDeals ? "&deal_active=true" : ""
              }`}
              onClick={() =>
                trackEvent(
                  Category.dealMenuPhenotypes,
                  Action.click,
                  `phenotype name - ${phenotype}`
                )
              }
              className={wrapperClass}
            >
              <div className={coinClass}>{coinContent(phenotype)}</div>
            </a>
          ) : (
            <button
              key={phenotype}
              onClick={handlePhenotypeClick}
              data-phenotype={phenotype}
              className={wrapperClass}
            >
              <div className={coinClass}>{coinContent(phenotype)}</div>
            </button>
          )
        )}
      </div>

      <style jsx>{`
        .coin__image {
          width: 120px;
        }
      `}</style>

      <style jsx>{`
        @media screen and (min-width: ${DeviceScreenSizes.Desktop}px) {
          .coin__image {
            width: 156px;
          }
        }
      `}</style>
    </>
  );
};

export default PhenotypeCarousel;
